import { z } from 'zod'
const numberRequired = (message: string) => z.number({ required_error: message }).min(1, message)
const stringRequired = (message: string) => z.string({ required_error: message }).min(1, message)

export const finishedStatusSchema = z.object({
  finishedReference: stringRequired("Reference is required"),
  alternateReference: z.string().nullable().optional(),
  displayedReference: z.string().nullable().optional(),
  colour: z.string().nullable().optional(),
  finish: z.string().nullable().optional(),
  fabricWidthValue: z
      .union([z.number(), z.string().transform((val) => parseFloat(val))])
      .nullable()
      .optional(),
  fabricWidthUnit: z.number().optional().nullable(),
  fabricYieldValue: z.union([
    z.number(),
    z.string().transform((val) => parseFloat(val))
  ]).refine((val) => !isNaN(val), {
    message: 'Fabric yield is required'
  }),
  fabricYieldUnit: z.number().optional().nullable(),
  averageRollLengthValue: z
      .union([z.number(), z.string().transform((val) => parseFloat(val))])
      .nullable()
      .optional(),
  averageRollLengthUnit: z.number().optional().nullable(),
})

export const unfinishedStatusSchema = z.object({
  unfinishedReference:stringRequired("Reference is required"),
})

export const productSpecificationSchema = z.object({
  fabricStatus: z.union([
    z.literal(0, { message: 'Fabric status is required' }),
    z.literal(1, { message: 'Fabric status is required' })
  ]),
  finishedReference: z.string().optional(),
  unfinishedReference: z.string().optional(),
  alternateReference: z.string().nullable().optional(),
  displayedReference: z.string().nullable().optional(),
  colour: z.string().nullable().optional(),
  finish: z.string().nullable().optional(),
  fabricWidthValue: z
      .union([z.number(), z.string().transform((val) => parseFloat(val))])
      .nullable()
      .optional(),
  fabricWidthUnit: z.number().optional().nullable(),
  fabricYieldValue: z.union([
    z.number(),
    z.string().transform((val) => parseFloat(val))
  ]).nullable().optional(),
  fabricYieldUnit: z.number().optional().nullable(),
  averageRollLengthValue: z
      .union([z.number(), z.string().transform((val) => parseFloat(val))])
      .nullable()
      .optional(),
  averageRollLengthUnit: z.number().optional().nullable(),
  construction: stringRequired("Construction is required"),
  standardBatchSize: numberRequired("Standard batch size cannot be less than one"),
  fabricWeight: z.union([z.number(), z.string().transform(val => parseFloat(val))]).nullable().optional(),
  fibreContent: z.string().nullable().optional(),
  guage: z.string().nullable().optional(),
}).superRefine((data, ctx) => {
  if (data.fabricStatus === 0) {
    const parsed = finishedStatusSchema.safeParse(data)
    if (!parsed.success) {
      parsed.error.errors.forEach(err => ctx.addIssue(err))
    }
  } else if (data.fabricStatus === 1) {
    const parsed = unfinishedStatusSchema.safeParse(data)
    if (!parsed.success) {
      parsed.error.errors.forEach(err => ctx.addIssue(err))
    }
  }
})
